import { Link } from "react-router-dom";
import { Article } from "../../interfaces/Article";
import { slugify } from "../../functions/slugify";
import { FaChevronRight } from "react-icons/fa";
import { format, parseISO } from "date-fns";
import { id } from "date-fns/locale";
import { enUS } from "date-fns/locale";
import { useIntl } from "react-intl";

interface Props {
  post: Article;
  locale: string;
}

const BlogCard: React.FC<Props> = ({ post, locale }) => {
  const intl = useIntl();
  const imageUrl =
    post.thumbnail && post.thumbnail.length > 0 ? post.thumbnail[0] : "";
  const categorySlug = slugify(post.category);
  const dateLocale = locale === "en" ? enUS : id;

  return (
    <div className="col-12 mb-4" key={post.id}>
      <Link
        to={`/blog/${post.id}/${slugify(post.title)}`}
        className="text-decoration-none"
      >
        <div
          className="position-relative w-100"
          style={{
            aspectRatio: "16 / 9",
            overflow: "hidden",
            backgroundColor: "#eee",
            boxShadow:
              "0 3px 12px -1px rgba(7, 10, 25, 0.2), 0 22px 27px -20px rgba(7, 10, 25, 0.2)",
          }}
        >
          {imageUrl && (
            <img
              src={imageUrl}
              alt={post.title}
              crossOrigin="anonymous"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "100%",
                height: "auto",
                transform: "translate(-50%, -50%)",
                objectFit: "cover",
                display: "block",
              }}
            />
          )}
        </div>
      </Link>

      <div className="card-body p-4 pb-3 text-start">
        {post.category && (
          <Link
            to={`/blog/category/${categorySlug}`}
            className="card category-tag mb-3 text-decoration-none"
          >
            {post.category}
          </Link>
        )}
        <Link
          to={`/blog/${post.id}/${slugify(post.title)}`}
          className="text-decoration-none text-dark"
        >
          <h4 className="card-title fw-bold mb-3 line-clamp-2">
            <span className="hover-underline">{post.title}</span>
          </h4>
        </Link>

        <div
          className="text-muted small align-items-center d-flex gap-2"
          style={{ textTransform: "uppercase" }}
        >
          <div>
            BY <span className="fw-semibold">Marketing Wooblazz</span>
          </div>
          <div>-</div>
          <div>
            {format(parseISO(post.createdAt), "d MMMM yyyy", {
              locale: dateLocale,
            })}
          </div>
        </div>
      </div>

      <div className="card-footer bg-transparent border-0 px-4 pb-3">
        <Link
          to={`/blog/${post.id}/${slugify(post.title)}`}
          className="btn btn-link p-0 text-primary fw-bold text-decoration-none d-flex align-items-center"
        >
          {intl.formatMessage({ id: "BLOG.READ_MORE" })}{" "}
          <FaChevronRight className="ms-2 small" />
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
